
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMediaLoop as ObiMediaLoopElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-media-loop.js';
 
 
 

 
 export const ObiMediaLoop = createComponent({
   react: React,
   tagName: 'obi-media-loop',
   elementClass: ObiMediaLoopElement,
   events: {
     
   }
  });
 
 